if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const collectionQuickAddSource = this.closest('[data-collection-quick-add-source]');
        const collectionQuickAddTrigger = collectionQuickAddSource?.querySelector(
          '[data-collection-quick-add-trigger], .quick-add__submit'
        );

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          const sectionsUrl = window.Shopify && Shopify.previewMode
            ? routes.cart_url
            : `${window.location.pathname}${window.location.search}`;

          formData.append('sections_url', sectionsUrl);
          // Mobile Safari does not reliably focus a tapped button. Use the
          // quick-add wrapper as the source of truth so closing the cart never
          // restores focus (and scroll) to an unrelated product-page control.
          this.cart.setActiveElement(
            collectionQuickAddTrigger || document.activeElement,
            collectionQuickAddSource?.dataset.collectionQuickAddContext
          );
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const collectionQuickAddSourceRequest = this.persistCollectionQuickAddSource(formData.get('id'));

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const collectionQuickAdd = this.closest('talli-collection-quick-add');
            const quickAddModal = this.closest('quick-add-modal');
            if (collectionQuickAdd) {
              // The tracking attribute is useful order metadata, but it must not
              // hold the visible cart interaction hostage to an extra request.
              // persistCollectionQuickAddSource handles its own network errors.
              const closeQuickAdd = collectionQuickAdd.hide(false);
              this.cart.renderContents(response);
              // Let the drawer open while the desktop panel finishes its closing
              // animation. Waiting first adds a noticeable 350 ms to every add.
              await closeQuickAdd;
            } else if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            if (!collectionQuickAdd) await collectionQuickAddSourceRequest;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async persistCollectionQuickAddSource(variantId) {
        const source = this.closest('[data-collection-quick-add-source]');
        if (!source || !variantId) return;

        const productTitle = source.dataset.collectionQuickAddProductTitle || 'Product';
        const sourceContext = source.dataset.collectionQuickAddContext === 'related_products'
          ? 'related_products_quick_add'
          : 'collection_quick_add';
        const variantSelect = this.form.querySelector('[data-collection-quick-add-variant]');
        const variantTitle = variantSelect?.selectedOptions?.[0]?.textContent?.trim();
        const sourceLabel = variantTitle && variantTitle !== 'Default Title'
          ? `${productTitle} — ${variantTitle}`
          : productTitle;
        const attributeKey = `__${sourceContext}_product_${variantId}`;
        const attributes = { [attributeKey]: sourceLabel };

        try {
          const response = await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ attributes }),
          });

          if (!response.ok) console.error('Collection quick-add source could not be saved.');
        } catch (error) {
          console.error(error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
